<script>
import { mapWritableState, } from 'pinia'
import { useAppUiStore, } from '@/assets/js/src/pinia/appUi'
import { useTrapKeyboard, } from '@/assets/js/src/util/composables/useTrapKeyboard'
import { useTranslation, } from '@/assets/js/src/util/composables/useTranslation'

export default {
    name: 'ClaimDialog',
    setup () {
        return {
            ...useTrapKeyboard(),
            ...useTranslation(),
        }
    },
    data () {
        return {
            dialog: false,
        }
    },
    computed: {
        ...mapWritableState(useAppUiStore, [
            'claim',
            'menu',
        ]) ,
    },
    watch: {
        'dialog': {
            handler (newValue, oldValue) {
                this.trapKeyboard(newValue, oldValue, () => {
                    this.dialog = false
                })
            },
            immediate: true,
        },
    },
    created () {
        this.promise = null
        this.reject = null
        this.resolve = null
    },
    methods: {
        okAction: function () {
            this.claim = false
            this.resolve()
        },
        cancelAction: function () {
            if(this.menu) {
                this.menu = false
            }
            this.reject()
        },
        beforeRouteLeave (to, from, next) {
            if(this.claim) {
                this.dialog = true
                this.promise = new Promise(function (resolve, reject) {
                    this.resolve = resolve
                    this.reject = reject
                }.bind(this))
                    .then(()=>{
                        // Claim löschen
                        next()
                    }).catch(()=>{
                        next(false)
                    }).finally(()=>{
                        this.dialog = false
                    })
            } else {
                next()
            }
        },
    },
}
</script>

<template>
    <div
        id="claimDialog"
    >
        <v-dialog
            v-model="dialog"
            persistent
            max-width="400"
            @keydown.stop.prevent.esc="cancelAction"
        >
            <v-card>
                <v-card-title class="text-h5">
                    {{ t('async.common.claimdialog.title') }}
                </v-card-title>
                <v-card-text>{{ t('async.common.claimdialog.text') }}</v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        variant="text"
                        @click="cancelAction"
                        @keyup.stop.prevent.enter="cancelAction"
                    >
                        {{ t('async.common.button.cancel') }}
                    </v-btn>
                    <v-btn
                        color="primary"
                        @click="okAction"
                        @keyup.stop.prevent.enter="okAction"
                    >
                        {{ t('async.common.button.discard') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<style lang="scss">
    .bs-app {
        .v-overlay--active {
            z-index: 10000 !important;
        }

        .v-dialog__content--active {
            z-index: 10001 !important;
        }
    }
</style>
